import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';

@Component({
  selector: 'app-gift-details-skeleton',
  templateUrl: './gift-details-skeleton.component.html',
  styleUrls: ['./gift-details-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class GiftDetailsSkeletonComponent {}
